import { render, staticRenderFns } from "./show-detail.vue?vue&type=template&id=56b64708&"
import script from "./show-detail.vue?vue&type=script&lang=js&"
export * from "./show-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports